import { defineComponent as _defineComponent } from 'vue'
import Icon from 'Src/js/components/Icon.vue';
import LinkButton from 'Src/js/components/LinkButton.vue';
import RewardsBadgeWithColor from 'Src/js/components/RewardsBadgeWithColor.vue';
import windowData from 'JS/global/window-data';
import { addCommas } from 'JS/helpers/functions';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EarnableRewardsCallout',
  props: {
    points: { default: "000.00" },
    isRewardsMember: { type: Boolean },
    isSignedIn: { type: Boolean, default: windowData.customer != null },
    location: { default: "checkout" },
    preferSideMenuEmit: { type: Boolean, default: false },
    skipCartMerge: { type: Boolean, default: false }
  },
  emits: ["open-side-menu"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'open-side-menu', sideMenu: 'rewards' | 'login'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { points: string, isRewardsMember: boolean, isSignedIn: boolean, location: "checkout" | "auto", preferSideMenuEmit: boolean, skipCartMerge: boolean }






const standardizedPoints = computed(()=> {
	return addCommas(parseFloat(props.points).toString());
});

function joinRewards() {
	if (props.preferSideMenuEmit) {
		emit('open-side-menu', props.isSignedIn ? 'rewards' : 'login');
	} else {
		Blain.Rewards.showJoinRewardsSidePanel('join', props.skipCartMerge);
	}
}



return { __sfc: true,props, emit, standardizedPoints, joinRewards, Icon, LinkButton, RewardsBadgeWithColor }
}

})